


























































































































































import {
  defineComponent,
  PropType,
  ref,
  toRefs,
  watch,
} from '@vue/composition-api'
import {
  getCities,
  getCountries,
  getRegions,
  getSubregions,
} from '~/api/Address/address'
import { getAgencies, invoiceController } from '~/api/Agency/agency.api'
import { Agency, Invoice } from '~/api/Agency/agency.interface'
import Autocomplete from '~/components/Autocomplete.vue'
import CreateDialog from '~/components/CreateDialog.vue'
import PhoneTextField from '~/components/PhoneTextField.vue'
import { crudEditComposition } from '~/compositions/crudEditComposition'
import { useVModel } from '~/compositions/useVModel'
import vRules from '~/utils/vRules'
import DatePicker from '~/components/DatePicker.vue'

export default defineComponent({
  components: { PhoneTextField, CreateDialog, Autocomplete, DatePicker },
  props: {
    value: { type: Boolean, default: false },
    editedItem: Object as PropType<Invoice>,
  },
  setup(props, ctx) {
    const { value } = toRefs(props)
    const model = useVModel<boolean>(value, ctx.emit)
    const agency = ref<Agency>()
    const composition = crudEditComposition(
      props,
      ctx,
      {
        name: '',
        cid: '',
        email: '',
        phone: '',
        address: {
          address_1: '',
          address_2: '',
          locality: '',
          city: null,
          subregion: null,
          region: null,
          country: null,
          zip_code: '',
        },
        description: '',
        amount: '0',
        type: 'CLIENT',
        unit_value: '20',
        commission_factor: '0.35',
        profit: null,
        operation_date: undefined,
      },
      invoiceController.createOrUpdateJson,
    )
    watch(model, v => {
      if (v) agency.value = undefined
    })
    return {
      model,
      ...composition,
      vRules,
    }
  },
  data() {
    return {
      getAgencies,
      getCountries,
      getRegions,
      getCities,
      getSubregions,
      invoiceTypes: ['AGENCY', 'CLIENT'].map(type => ({
        text: this.$t(type),
        value: type,
      })),
    }
  },
  methods: {
    onSelectedAgency(e: Agency) {
      this.crud.name = e.name
      this.crud.cid = e.cid
      this.crud.address.address_1 = e.address.address_1
      this.crud.email = e.email
      this.crud.phone = e.phone
    },
  },
})
